import { css } from '@emotion/react';
import { colors } from '../../../utils/styleguide';
import { withTranslation } from '../../../utils/i18n';
import styled from '@emotion/styled';
import { useState } from 'react';
import { I18n } from 'next-i18next';

// @ts-expect-error ts-migrate(2769) FIXME: Type '{ <S extends string>(callbackfn: (value: str... Remove this comment to see the full error message
const Select = styled.select`
  font-family: Sharp-Grotesk;
  width: 100%;
  height: 48px;
  appearance: none;
  padding: 8px;
  border: none;
  color: ${colors.white};
  background-color: ${colors.black};
  background-image: url(/static/images/flags/language/${({ value }) => value}.svg),
    url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: left 0.7em top 50%, right 0.7em top 50%;
  background-size: 1.5em auto, 0.65em auto;
  padding-left: 48px;
  padding-right: 34px;
  max-width: fit-content;
`;

type Props = {
  name?: string;
  options?: { label: string; code: string }[];
  value?: string;
  onChange?: (value: string) => void;
};

const DropDown = ({ name, options = [], value, onChange = () => {} }: Props) => (
  <Select name={name} value={value} onChange={(e) => onChange(e.currentTarget.value)}>
    {options.map(({ label, code }) => (
      <option key={code} value={code}>
        {label}
      </option>
    ))}
  </Select>
);

const SELECTABLE_LANGUAGES = [
  { label: 'English', code: 'en' },
  { label: 'Svenska', code: 'sv' },
  { label: 'Deutsch', code: 'de' },
];

const LanguageDropdown = withTranslation('common')(
  ({ i18n, className }: { i18n: I18n; className?: string }) => {
    const [selectedLanguageLabel, selectLanguage] = useState(i18n.language);

    const changeLanguage = (code: string) => {
      selectLanguage(code);
      i18n.changeLanguage(code);
    };

    return (
      <div
        className={className}
        css={css`
          margin: 0;
          color: white;
        `}
      >
        <DropDown
          value={selectedLanguageLabel}
          onChange={changeLanguage}
          options={SELECTABLE_LANGUAGES}
        />
      </div>
    );
  },
);

export default LanguageDropdown;
